import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import {AuthService} from '../../core/security/auth.service';
import {PhoneNumbersService} from '../phone-numbers.service';
import {SavePhoneNumbersRequest} from '../../api/models/save-phone-numbers-request';
import {cnamValidator} from '../../core/validators/cnam.validator';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatButton } from '@angular/material/button';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

export interface BulkEditDialogData {
  ids: string[];
  cnam: string;
}

@Component({
    selector: 'app-phone-number-bulk-edit',
    templateUrl: './bulk-edit.component.html',
    styleUrls: ['./bulk-edit.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, NgIf, MatTextInputComponent, MatDialogActions, MatButton, MatDialogClose, Angular2PromiseButtonModule]
})
export class BulkEditComponent implements OnInit, OnChanges {

  public form: UntypedFormGroup;
  public submitted: boolean;
  public serverError: boolean;
  buttonSubmitPromise: Promise<void>;

  public opened = false;

  onConfirm: Promise<void>;
  @Input() autoClose: boolean;
  @Input() asyncConfirm: (filter?: any) => Promise<void>;
  @Output() onSuccess = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: BulkEditDialogData,
              public dialogRef: MatDialogRef<BulkEditComponent>,
              public phoneNumbersService: PhoneNumbersService,
              private fb: UntypedFormBuilder,
              private authService: AuthService,
              private notificationService: NotificationService) {

    this.createForm();
  }

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {

    this.submitted = false;
    this.form.reset({
      cnam: this.data.cnam,
    });
  }

  async onSubmit() {
    this.submitted = true;
    this.serverError = false;

    if (this.form.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    }
  }

  async processSubmit(): Promise<void> {
    const reqData = this.prepareFormModel();

    if (await this.phoneNumbersService.savePhoneNumbers(reqData)) {
      this.notificationService.notifySuccess('The changes have been submitted successfully');

      this.dialogRef.close('success');

      this.ngOnChanges();
    } else {
      this.serverError = true;
    }
  }

  prepareFormModel(): SavePhoneNumbersRequest {
    const formModel = this.form.value;

    return {
      ids: this.data.ids,
      cnam: formModel.cnam
    };
  }

  createForm(): void {
    this.form = this.fb.group({
        'cnam': ['', cnamValidator]
      }
    );
  }

  async onProcessConfirm() {
    if (this.asyncConfirm) {
      this.onConfirm = this.asyncConfirm();
    }
  }

  getFormControl(controlName: string): UntypedFormControl {
    return  this.form.get(controlName) as UntypedFormControl;
  }
}
